import { render, staticRenderFns } from "./inquiry-price-goods-cloud-rent.vue?vue&type=template&id=36f15485&scoped=true&"
import script from "./inquiry-price-goods-cloud-rent.vue?vue&type=script&lang=js&"
export * from "./inquiry-price-goods-cloud-rent.vue?vue&type=script&lang=js&"
import style0 from "./inquiry-price-goods-cloud-rent.vue?vue&type=style&index=0&id=36f15485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f15485",
  null
  
)

export default component.exports